const STORAGE_KEY = 'challengeSwitchContext';

export function getChallengeSwitchContext() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.parentUserDetailId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function setChallengeSwitchContext(context) {
  const next = {
    parentUserDetailId: context.parentUserDetailId,
    parentUserName: context.parentUserName || '',
    parentUserAccountId: context.parentUserAccountId || '',
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function clearChallengeSwitchContext() {
  localStorage.removeItem(STORAGE_KEY);
}

export function resolveParentUserDetailId(currentUserDetailId) {
  const context = getChallengeSwitchContext();
  if (context?.parentUserDetailId) {
    return Number(context.parentUserDetailId);
  }
  return currentUserDetailId ? Number(currentUserDetailId) : null;
}

export function getParentUserDetailIdForChildUsersApi(currentUserDetailId) {
  const context = getChallengeSwitchContext();
  if (context?.parentUserDetailId) {
    return Number(context.parentUserDetailId);
  }
  return currentUserDetailId ? Number(currentUserDetailId) : null;
}

export function hasChallengeSwitchContext() {
  return Boolean(getChallengeSwitchContext()?.parentUserDetailId);
}

export const CHALLENGE_PARENT_SWITCH_REASONS = [
  'phase_transition',
  'challenge_failed',
  'challenge_completed',
];

export function shouldSwitchToParentOnChallengeLogout(reason) {
  return (
    hasChallengeSwitchContext() &&
    CHALLENGE_PARENT_SWITCH_REASONS.includes(reason)
  );
}
